import { PeekDateRangeInput, PeekInputCheckbox } from "@piiqtechnologies/ui-components";
import dayjs from "dayjs";
import { useIntl } from "react-intl";
import * as yup from "yup";
import CommunitiesSelector from "./CommunitiesSelector";
import messages from "./messages.i18n";
import { AnalyticsReportType } from "@piiqtechnologies/ui-lib";
export const ReportLabels = {
    // [AnalyticsReportType.Conversion]: messages.conversionTitle,
    [AnalyticsReportType.SgtEngagement]: messages.sgtEngagementTitle,
    [AnalyticsReportType.VirtualTourEngagement]: messages.virtualTourEngagementTitle,
    [AnalyticsReportType.FloorPlanViews]: messages.floorplanViewsTitle,
    [AnalyticsReportType.LayoutViews]: messages.layoutViewsTitle,
    [AnalyticsReportType.AmenityViews]: messages.amenityViewsTitle,
    [AnalyticsReportType.ReferralSources]: messages.referralSourcesTitle,
    [AnalyticsReportType.ContentCreation]: messages.contentCreationTitle,
};
export const DownloadAnalyticsFormValidationSchema = () => {
    return yup.object(Object.assign({ dateRange: yup.object({
            startDate: yup.date().required(),
            endDate: yup.date().required(),
        }) }, Object.values(AnalyticsReportType).reduce((acc, reportType) => {
        acc[reportType] = yup.boolean();
        return acc;
    }, {})));
};
export const DownloadAnalyticsFormInitialValues = (period, communities) => {
    return {
        dateRange: {
            startDate: dayjs(period.startDate),
            endDate: dayjs(period.endDate),
        },
        communities,
        sgtEngagement: true,
        virtualTourEngagement: false,
        floorPlanViews: true,
        layoutViews: true,
        amenityViews: true,
        referralSources: true,
        contentCreation: true,
    };
};
export const DownloadAnalyticsFormFields = (communityOptions) => {
    const intl = useIntl();
    return {
        dateRange: {
            fields: [
                {
                    id: "dateRange",
                    label: intl.formatMessage(messages.dateRangeTitle),
                    placeholder: "",
                    required: true,
                    columns: 6,
                    isAbsolute: false,
                    component: PeekDateRangeInput,
                },
            ],
        },
        communities: {
            fields: [
                {
                    id: "communities",
                    label: intl.formatMessage(messages.communitiesTitle),
                    placeholder: "",
                    required: false,
                    columns: 12,
                    isAbsolute: false,
                    component: CommunitiesSelector,
                    options: communityOptions,
                },
            ],
        },
        others: {
            fields: Object.values(AnalyticsReportType).map((reportType) => ({
                id: reportType,
                label: intl.formatMessage(ReportLabels[reportType]),
                placeholder: "",
                required: false,
                columns: 12,
                isAbsolute: false,
                type: "checkbox",
                component: PeekInputCheckbox,
            })),
        },
    };
};
